const testimonials = [  
    { 
        id: 1,
        name: 'Ahmed Khan', 
        title: 'Community Member',
        content: 'Attending Siraj Islamic Center has deepened my connection with faith and community. The environment is welcoming, and the programs are truly inspiring.'
    }, 
    { 
        id: 2,
        name: 'Fatima Zahra', 
        title: 'Youth Volunteer',
        content: "The youth programs here have given me a sense of purpose and belonging. I’ve learned valuable skills and made lifelong friends."
    },
    { 
        id: 3,
        name: 'Muhammad Ali', 
        title: 'Local Business Owner',
        content: 'Supporting the mosque has been an honor. The center plays an important role in promoting unity, education, and charity in our community.'
    },    
    { 
        id: 4,
        name: 'Aisha Siddiqui', 
        title: 'Parent',
        content: "My children love attending the weekend Islamic classes. The teachers are kind, knowledgeable, and make learning about Islam enjoyable."
    },
];

export default testimonials;